<template>
  <div class="radio-container" :class="{error:error}">
    <div>
      <div v-for="(option,index) in options" :key="index" :class="{ wrap: wrap }">
        <label>
          <input 
            type="radio" 
            class="input-radio"
            :name="formname" 
            :value="option.val"
            v-model="selectValue"
            v-bind="$attrs"
            :disabled="disabled"
          /><span :class="{'no-label': option.label == ''}">{{ option.label }}</span>
        </label>
      </div>
    </div>
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: ['options','name','modelValue', 'wrap', 'error', 'disabled'],
  setup(props, context) {
    const selectValue = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        context.emit('update:modelValue', val)
        context.emit('update', val)
      }
    })
    const formname = (props.name) ? props.name : 'inputradio-'+ Math.random().toString(36).substring(7)
    return {
      selectValue,
      formname
    }
  },
  emits: ['update:modelValue', 'update']
})
</script>

<style lang="scss" scoped>
@import '@scss/form/input-radio.scss';
</style>